import { render, staticRenderFns } from "./importMusicDetail.vue?vue&type=template&id=ad929ce4&scoped=true"
import script from "./importMusicDetail.vue?vue&type=script&lang=js"
export * from "./importMusicDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad929ce4",
  null
  
)

export default component.exports